/**
 * Public theme API.
 *
 * Import from `@/lib/theme` everywhere — never reach into `./tokens` or
 * `./ThemeProvider` directly. This keeps the surface tidy and lets us reorganise
 * internals without breaking call-sites.
 *
 * Examples:
 *
 *   // React component reading a colour at runtime:
 *   import { useTheme } from "@/lib/theme";
 *   const theme = useTheme();
 *   <svg fill={theme.colors.brand.DEFAULT} />
 *
 *   // App root (already wired in `<Providers>`):
 *   import { ThemeProvider } from "@/lib/theme";
 *   <ThemeProvider>{children}</ThemeProvider>
 *
 *   // Build-time consumer (tailwind.config.ts):
 *   import { v2TailwindColors, v2TailwindRadii } from "@/lib/theme";
 */

export {
  V2_COLORS,
  V2_RADII,
  V2_FONT,
  V2_SIZES,
  V2_BREAKPOINTS,
  V2_THEME,
  v2TailwindColors,
  v2TailwindRadii,
} from "./tokens";

export type {
  V2Theme,
  V2ColorTokens,
  V2RadiiTokens,
  V2FontTokens,
  V2SizeTokens,
  V2BreakpointTokens,
} from "./tokens";

export { ThemeProvider, useTheme } from "./ThemeProvider";
